import { tagihanSiswa } from '../action-types';

const initialState = {
  data: null,
  dataByNis: null,
  isFetching: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case tagihanSiswa.FETCH_TAGIHANSISWA:
      return {
        ...state,
        isFetching: true,
      };
    case tagihanSiswa.GET_TAGIHANSISWA:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
      };
    case tagihanSiswa.GET_TAGIHAN_BY_NIS:
      return {
        ...state,
        isFetching: false,
        dataByNis: action.payload,
      };
    default:
      return state;
  }
};
